import angular from 'angular';

import template from './tsz-import-csv.html';
import './tsz-import-csv.styl';

import modalTpl from './modals/modal.html';

function controller($mdDialog) {

  'ngInject';

  this.showModal = (ev) => {

    $mdDialog.show({
      controller: ($scope, $rootScope, ReportService) => {

        $scope.loading = false;

        $scope.close = () => {
          $mdDialog.hide();
        };

        $scope.importCsv = (csv) => {
          ReportService.download_csv(csv)
          .then((report) => {
            $scope.close();
            $rootScope.$broadcast('import_report', report);
          }).catch(() => {
            $scope.serverError = 'No se ha encontrado ningún proyecto con el CSV especificado';
          });
        };
      },
      template: modalTpl,
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose:true,
      fullscreen: false, // Only for -xs, -sm breakpoints.
    });
  };

}

export default {
  template,
  controller,
};



// WEBPACK FOOTER //
// ./src/components/tsz-import-csv/tsz-import-csv.js